/**
 * Route for `prestashop-integration-via-webhook`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PrestashopIntegrationViaWebhookPage } from "../features/prestashop-integration-via-webhook/PrestashopIntegrationViaWebhookPage";

export const prestashopIntegrationViaWebhookRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/prestashop-integration-via-webhook",
	component: PrestashopIntegrationViaWebhookPage,
});

export default prestashopIntegrationViaWebhookRoute;
